<template>
  <v-container>
    <v-alert v-if="interruptReason" tile dense type="error">{{ interruptReason }}</v-alert>
    <v-form v-model="valid" @submit.prevent="sendOpenAccount">
      <div class="mb-10">
        <template v-if="!chosenTariff">
          <div class="d-flex req-title mb-6">
            <h3 class="font font--h3">
              Выберите тариф
            </h3>
            <div class="flex-grow-1"></div>
          </div>

          <v-select
            hide-details
            :rules="planRules"
            :menu-props="{ bottom: true, offsetY: true }"
            single-line
            dense
            item-text="title"
            item-value="alias"
            v-model="tariffAlias"
            :items="tariffs"
            label="Тарифы"
            outlined
            class="mb-6"
          ></v-select>
        </template>

        <div v-if="account_tariffs.has_card_data === true">
          <div class="d-flex req-title mb-6">
            <h3 class="font font--h3">
              Введите номер карты
            </h3>
            <div class="flex-grow-1"></div>
          </div>

          <v-row>
            <v-col class="pb-0">
              <v-text-field
                :rules="technumberRules"
                outlined
                dense
                label="Тех.номер"
                v-model="technumber"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0">
              <v-text-field
                v-mask="'### ### ### ### ### ### ###'"
                :rules="IbsoidRules"
                outlined
                dense
                label="IBSO ID"
                v-model="Ibsoid"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-btn type="submit" class="mt-8" :disabled="!valid" block color="primary">Открыть счёт</v-btn>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import { mask } from "vue-the-mask";
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { processMeetingOpen } from "@/api";
import { required } from "@/utils/rules";

const sixDigits = (v) => /^\d{6}$/.test(v) || "Номер состоит из 6 цифр";
const onlyDigits = (v) => /^\d+$/.test(v.replace(/\s/g, "")) || "Только цифры";

export default {
  directives: { mask },

  data() {
    return {
      // tariffId: null,
      tariffAlias: null,
      technumber: "",
      Ibsoid: "",
      valid: false,
      planRules: [required("Выберите тариф")],
    };
  },
  computed: {
    ...mapState("meeting", ["currentMeetingId"]),
    ...mapGetters("meeting", [
      "meetingdocs",
      "account_tariffs",
      "chosenTariff",
      "interruptReason",
      "cardData",
      "tariffs",
      "survey_accopen",
    ]),
    technumberRules() {
      return this.Ibsoid ? [required("Введите тех.номер"), sixDigits] : [(v) => !v || sixDigits(v)];
    },
    IbsoidRules() {
      return this.technumber ? [required("Введите IBSO ID"), onlyDigits] : [(v) => !v || onlyDigits(v)];
    },
  },

  mounted() {
    if (this.cardData) {
      if (this.cardData.technumber) {
        this.technumber = this.cardData.technumber;
      }
      if (this.cardData.Ibsoid) {
        this.Ibsoid = this.cardData.Ibsoid;
      }
    }
  },

  watch: {
    cardData: {
      deep: true,
      handler(data) {
        if (data?.technumber) {
          this.technumber = data.technumber;
        }
        if (data?.Ibsoid) {
          this.Ibsoid = data.Ibsoid;
        }
      },
    },
  },

  methods: {
    ...mapActions("meeting", ["getMeetingById"]),
    ...mapMutations("meeting", ["setAccountOpenStep"]),

    async sendOpenAccount() {
      const data = {
        oid: this.currentMeetingId,
      };

      if (!this.chosenTariff) {
        // data.tariffId = this.tariffId;
        data.tariffAlias = this.tariffAlias;
      }

      if (this.technumber && this.Ibsoid) {
        data.card = {
          technumber: this.technumber,
          Ibsoid: this.Ibsoid.replace(/\s/g, ""),
        };
      }

      if (this.survey_accopen) {
        data.survey = {
          type: "account_open",
          data: this.survey_accopen.data,
        };
      }

      data.is_typical_statute = this.$store.state.meeting.isTypicalStatute; // FIXME: отправлять на шаге документов, а не при открытии. бэк пока не готов

      const res = await processMeetingOpen(data);
      if (res) {
        await this.getMeetingById(this.currentMeetingId);
        this.setAccountOpenStep(0);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.req-title {
  & > * {
    padding-bottom: 8px;
    border-bottom: 2px rgba(0, 0, 0, 0.0947973) solid;
  }
  h3 {
    border-bottom-color: #4971d0;
  }
}
</style>
